import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Recipe from '../../components/recipe/Recipe';
import { getRecipe } from '../../helpers/Request';
import useTitle from '../../hooks/useTitle';

export function RecipeDetail () {
    const { id } = useParams();
    const [recipe, setRecipe] = useState(null);
    const [loader, setLoader] = useState(true);
    const [, setTitle] = useTitle('Receta')

    useEffect(() => {
        setLoader(true);
        getRecipe(id)
            .then(data => {
                setRecipe(data);
                setTitle(data.title)
            })
            .catch(_ => {
                console.log(_)
                alert('Ocurrió un error al cargar la receta.');
            })
            .finally(() => {
                setLoader(false);
            });
    }, [id, setTitle]);

    function getLoader() {
        return loader && (<div className="loader">
            <img src="/loader.svg" alt="loader" />
            <p>Cargando receta</p>
        </div>);
    }

    return (
        <>
            {getLoader()}
            {recipe && !loader && (<Recipe recipe={recipe}/>)}
        </>
    );
}
